import { ExpandMore } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
} from '@mui/material';
import * as React from 'react';

import { WorklistRowMode } from '~/scenes/MyWorkspace/components/Widgets/components/MyWorklistsWidget/components/common';
import { useSxStyles } from '~/scenes/MyWorkspace/components/Widgets/components/MyWorklistsWidget/components/common/WorklistPanels/useStyles';
import { WorklistPanelSummary } from '~/scenes/MyWorkspace/components/Widgets/components/MyWorklistsWidget/components/common/WorklistPanels/WorklistPanelSummary';
import { WorklistPanelTasks } from '~/scenes/MyWorkspace/components/Widgets/components/MyWorklistsWidget/components/common/WorklistPanels/WorklistPanelTasks';
import { WorklistDto } from '~/services/Http/client.people.generated';

type PropsType = {
  worklistData: WorklistDto[];
  selectedTasks: Record<number, boolean>;
  setSelectedTasks: React.Dispatch<
    React.SetStateAction<Record<number, boolean>>
  >;
  rowMode: WorklistRowMode;
  widgetContentRef: React.MutableRefObject<null>;
  myWorklists: boolean;
};

export const WorklistPanels = (props: PropsType) => {
  const {
    worklistData,
    selectedTasks,
    setSelectedTasks,
    rowMode,
    widgetContentRef,
    myWorklists,
  } = props;

  const sxStyles = useSxStyles();

  return (
    <>
      {worklistData && (
        <Box data-cy="list" sx={sxStyles.list} ref={widgetContentRef}>
          {worklistData.map((listItem) => (
            <Box data-cy="list-item" key={listItem.id}>
              <Accordion key={listItem.id} sx={sxStyles.expansionPanel}>
                <AccordionSummary
                  expandIcon={<ExpandMore data-cy="expansion-icon" />}
                  sx={sxStyles.expansionPanelSummary}
                >
                  <WorklistPanelSummary listItem={listItem} />
                </AccordionSummary>
                <AccordionDetails sx={sxStyles.expansionPanelDetails}>
                  <WorklistPanelTasks
                    tasks={[...listItem.tasks].sort((a, b) => a.id - b.id)}
                    selectedTasks={selectedTasks}
                    setSelectedTasks={setSelectedTasks}
                    rowMode={rowMode}
                    myWorklists={myWorklists}
                  />
                </AccordionDetails>
              </Accordion>
            </Box>
          ))}
        </Box>
      )}
    </>
  );
};
